import React, { useState, useRef } from 'react'

type MinLengthTextareaProps = React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & {
  value: string
  onValidChange: (valid: boolean) => void
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  minLength: number
  prompt: string
}

/**
 * Primary justification for this component is to only show an error after blur but to avoid giving 
 * away the exact length of text that's required.
 */
export const MinLengthTextarea = ({
  value,
  onChange,
  onValidChange,
  minLength,
  prompt,
  ...props
}: MinLengthTextareaProps) => {
  const [touched, setTouched] = useState(false)
  const [rerender, setRerender] = useState(0)
  const ref = useRef<HTMLTextAreaElement>(null)

  const isError = () => (
    touched &&
    document.activeElement !== ref.current &&
    value.length < minLength
  )

  const _isError = isError()

  return <div className="validated-input">
    <textarea className={`form-control ${_isError ? 'error' : ''}`} key={rerender}
      onChange={onChange}
      value={value}
      ref={ref}
      onBlur={e => {
        setTouched(true)
        props.onBlur?.(e)
        setRerender(r => r + 1)
        onValidChange(value.length >= minLength)
      }}
      {...props}
    />
    {_isError ? <p className="small error text-end">{prompt}</p> : null}
  </div>
}

export default MinLengthTextarea